/**
 * CWR 2.4 — service stats card: Duration · Format · Price (mockup .sd-stats).
 */
import type { HubServiceDetailDto } from '@/api/types';
import { modalityLabel } from '@/pages/BookSessionPage/catalogFormat';
import { formatDuration, servicePriceText } from '../detailFormat';
import styles from '../SessionDetailPage.module.css';

export interface ServiceStatsProps {
  duration: number;
  modality: HubServiceDetailDto['modality'];
  pricing: HubServiceDetailDto['pricing'];
}

export function ServiceStats({ duration, modality, pricing }: ServiceStatsProps) {
  return (
    <div className={styles.stats}>
      <div className={styles.stat}>
        <span className={styles.statLbl}>Duration</span>
        <span className={styles.statVal}>{formatDuration(duration)}</span>
      </div>
      <div className={styles.stat}>
        <span className={styles.statLbl}>Format</span>
        <span className={styles.statVal}>{modalityLabel(modality)}</span>
      </div>
      <div className={styles.stat}>
        <span className={styles.statLbl}>Price</span>
        <span className={`${styles.statVal} ${styles.price}`}>{servicePriceText(pricing)}</span>
      </div>
    </div>
  );
}
